document.addEventListener("DOMContentLoaded", function () {
    const prevButton = document.querySelector(".prev-btn");
    const nextButton = document.querySelector(".next-btn");
    const carouselItems = document.querySelectorAll(".carousel-item");
    let currentIndex = 0;

    // Verifica se há itens no carrossel
    if (carouselItems.length === 0) {
        console.error("Nenhum item encontrado no carrossel!");
        return;
    }

    // Inicializa o primeiro item como ativo
    carouselItems[currentIndex].classList.add("active");

    function showItem(index) {
        // Remove as classes antigas
        carouselItems.forEach((item) => {
            item.classList.remove("active", "prev", "next");
        });

        // Calcula os índices anterior e próximo
        const prevIndex = (index - 1 + carouselItems.length) % carouselItems.length;
        const nextIndex = (index + 1) % carouselItems.length;

        // Aplica as classes
        carouselItems[prevIndex].classList.add("prev");
        carouselItems[nextIndex].classList.add("next");
        carouselItems[index].classList.add("active");
    }

    // Botão "Próximo"
    nextButton.addEventListener("click", function () {
        currentIndex = (currentIndex + 1) % carouselItems.length;
        showItem(currentIndex);
    });

    // Botão "Anterior"
    prevButton.addEventListener("click", function () {
        currentIndex = (currentIndex - 1 + carouselItems.length) % carouselItems.length;
        showItem(currentIndex);
    });
});

document.addEventListener('shopify:block:select', function(event) {
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function() {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft
    });
  }, 200);
});





